import MDTypography from 'components/MDTypography';

export const AccordionLabel = ({ tracker }) => {
  return (
    <>
      <MDTypography
        variant="body2"
        component="span"
        fontWeight="bold"
        textTransform="capitalize"
      >
        {tracker?.name}
      </MDTypography>
      <MDTypography
        color="text"
        variant="body2"
        component="span"
        fontWeight="regular"
      >
        | semester: {tracker.semester}
      </MDTypography>
    </>
  );
};
